import styled from 'styled-components';

const ScreenDropPreviewContainer = styled.div`
  width: 100%;
  height: 47px;
  background: ${({ theme }) => theme.color.background.highlight};
  border-radius: 4px;
`;

export const ScreenDropPreview = ({ isOver }: { isOver: boolean }) => {
  if (!isOver) return null;
  return <ScreenDropPreviewContainer />;
};
